'use es6';

export const getPublicRootUrl = () => `/developer-docs`;